import React, { useState, useEffect } from "react";
import {
  Nav,
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Alert,
} from "react-bootstrap";
import "./style/Dashboard.css";
import MerchantSideBar from "./elements/MerchantSideBar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FacilityTable from "../components/elements/FacilityTable.jsx";
import { db } from "../firebase";
import { collection, doc, addDoc } from "firebase/firestore";
import LogoIcon from "./assets/img/logo-main.png";

export default function Dashboard() {
  const [showModal, setShowModal] = useState(false);
  const [currentUserDetails, setCurrentUserDetails] = useState();

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const facilityTypes = ["Toilet", "Rest", "Other"];
  const [facilityName, setFacilityName] = useState("");
  const [facilityDescription, setFacilityDescription] = useState("");
  const [facilityLocation, setFacilityLocation] = useState("");
  const [facilityType, setFacilityType] = useState("Toilet");
  const [customDescription, setCustomDescription] = useState("");
  const [isCustomDescription, setIsCustomDescription] = useState(false);
  const [error, setError] = useState("");
  const [inputError, setInputError] = useState("");
  document.title ='Dashboard - Hentian Komuniti';

  useEffect(() => {
    const storedUser = sessionStorage.getItem("currentUserDetail");
    if (storedUser) {
      if (!currentUserDetails) {
        setCurrentUserDetails(JSON.parse(storedUser));
      }
    } else {
      console.log("No user found in session storage");
    }
  }, [currentUserDetails, setCurrentUserDetails]);

  const handleAddFacility = async () => {
    if (
      (!facilityName || facilityName.trim() === "") &&
      (!facilityDescription || facilityDescription.length === 0)
    ) {
      return setError(
        "Facility Name and Facility description should not be empty"
      );
    }

    if (!facilityName || facilityName.trim() === "") {
      return setError("Facility Name should not be empty");
    }

    if (!facilityDescription || facilityDescription.length === 0) {
      return setError("Facility description should not be empty");
    }

    if (isCustomDescription && customDescription.length === 0) {
      return setError("Custom description should not be empty");
    }

    try {
      const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      const facilityData = {
        merchant_id: currentUser.uid,
        type: facilityType,
        merchant_name: currentUserDetails.name,
        facilityName: facilityName,
        description: facilityDescription,
        isCustomDescription: isCustomDescription,
        customDescription: customDescription,
        location: facilityLocation,
        rating: 0,
        latitude: currentUserDetails.latLng[0],
        longitude: currentUserDetails.latLng[1],
      };
      console.log(facilityData);
      await addDoc(collection(db, "facility"), facilityData);
      setFacilityDescription("");
      setFacilityName("");
      setCustomDescription("");
      setFacilityLocation("");
      setIsCustomDescription(false);
      setFacilityType("")
      setError("");
      handleClose();
    } catch (error) {
      console.error("Error adding facility: ", error);
    }
  };

  const handleCheckboxChange = (option, e) => {
    let updatedDescriptions;
    if (option === "Others") {
      console.log("ajhahsihi");
      updatedDescriptions = e.target.checked
        ? [...facilityDescription, "Others"]
        : facilityDescription.filter((desc) => desc !== "Others");
      if (!e.target.checked) {
        setCustomDescription("");
        setIsCustomDescription(false);
      } else {
        setIsCustomDescription(true);
      }
    } else {
      updatedDescriptions = e.target.checked
        ? [...facilityDescription, option]
        : facilityDescription.filter((desc) => desc !== option);
      setCustomDescription(""); // Clear the custom description when a checkbox option is selected
    }
    setFacilityDescription(updatedDescriptions);
  };

  // const getFinalDescription = () => {
  //   let finalDescription = [...facilityDescription];

  //   // If "Others" is selected, add customDescription to the finalDescription
  //   if (facilityDescription.includes("Others") && customDescription) {
  //     finalDescription = [
  //       ...finalDescription.filter((desc) => desc !== "Others"),
  //       customDescription,
  //     ];
  //   }

  //   return finalDescription.join(", "); // Combine descriptions into one string (you can adjust this formatting as needed)
  // };

  return (
    <div className="d-flex">
      <div className="col-12">
        <div className="mt-2 ms-4">
          <h3 className="company-name">
            <span className="">
              <img src={LogoIcon} className="me-2 logo-merchant"></img>
            </span>
            {currentUserDetails && currentUserDetails.name}
          </h3>
        </div>
        <hr id="line" className="text-secondary"></hr>
        <div>
          <Row className="d-flex justify-content-between">
            <Col xs="auto" className="ms-4">
              <i className="bi bi-buildings fs-3"></i>
              <span className="fs-5 ms-2">List of Facility</span>
            </Col>
            <Col xs="auto" className="ms-3 me-sm-5">
              <Button id="button" className="border-0" onClick={handleShow}>
                <i className="bi bi-plus-lg"></i> Add Facility
              </Button>
            </Col>
          </Row>
        </div>
        <FacilityTable />

        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <i class="bi bi-plus-lg fs-4 me-2"></i>
            <Modal.Title className="fs-5">Add Facility</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="facilityName">
                <Form.Label>
                  Facility Name <span className="req">*</span>
                  {inputError && (
                    <span className="req-input">{inputError}</span>
                  )}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={facilityName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 50) {
                      setFacilityName(inputValue);
                      setInputError("");
                    } else {
                      setFacilityName(inputValue.slice(0, 50));
                      setInputError("should not longer than 50 character");
                    }
                  }}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="facilityLocation">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="eg: first floor"
                  value={facilityLocation}
                  onChange={(e) => setFacilityLocation(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="facilityType">
                <Form.Label>
                  Type <span className="req">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  value={facilityType}
                  onChange={(e) => {
                    setFacilityType(e.target.value);
                    setFacilityDescription([]); // Reset description when type changes
                    setCustomDescription("");
                  }}
                >
                  {facilityTypes.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3" controlId="facilityDescription">
                <Form.Label>
                  Description <span className="req">*</span>
                </Form.Label>
                {facilityType === "Toilet" && (
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="Male Toilet"
                      checked={facilityDescription.includes("Male Toilet")}
                      onChange={(e) => handleCheckboxChange("Male Toilet", e)}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Female Toilet"
                      checked={facilityDescription.includes("Female Toilet")}
                      onChange={(e) => handleCheckboxChange("Female Toilet", e)}
                    />

                    <Form.Check
                      type="checkbox"
                      label="Family Toilet"
                      checked={facilityDescription.includes("Family Toilet")}
                      onChange={(e) => handleCheckboxChange("Family Toilet", e)}
                    />

                    <Form.Check
                      type="checkbox"
                      label="OKU Toilet"
                      checked={facilityDescription.includes("OKU Toilet")}
                      onChange={(e) => handleCheckboxChange("OKU Toilet", e)}
                    />

                    <Form.Check
                      type="checkbox"
                      label="Others"
                      checked={facilityDescription.includes("Others")}
                      onChange={(e) => handleCheckboxChange("Others", e)}
                    />
                    {facilityDescription.includes("Others") && (
                      <Form.Control
                        type="text"
                        placeholder="Enter description"
                        value={customDescription}
                        onChange={(e) => setCustomDescription(e.target.value)}
                        required
                      />
                    )}
                  </div>
                )}

                {facilityType === "Rest" && (
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="Seating Area"
                      checked={facilityDescription.includes("Seating Area")}
                      onChange={(e) => handleCheckboxChange("Seating Area", e)}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Restrooms"
                      checked={facilityDescription.includes("Restrooms")}
                      onChange={(e) => handleCheckboxChange("Restrooms", e)}
                    />

                    <Form.Check
                      type="checkbox"
                      label="Pet-Friendly Zone"
                      checked={facilityDescription.includes(
                        "Pet-Friendly Zone"
                      )}
                      onChange={(e) =>
                        handleCheckboxChange("Pet-Friendly Zone", e)
                      }
                    />

                    <Form.Check
                      type="checkbox"
                      label="Tables and Chairs"
                      checked={facilityDescription.includes(
                        "Tables and Chairs"
                      )}
                      onChange={(e) =>
                        handleCheckboxChange("Tables and Chairs", e)
                      }
                    />

                    <Form.Check
                      type="checkbox"
                      label="Others"
                      checked={facilityDescription.includes("Others")}
                      onChange={(e) => handleCheckboxChange("Others", e)}
                    />
                    {facilityDescription.includes("Others") && (
                      <Form.Control
                        type="text"
                        placeholder="Enter description"
                        value={customDescription}
                        onChange={(e) => setCustomDescription(e.target.value)}
                        required
                      />
                    )}
                  </div>
                )}

                {facilityType === "Other" && (
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="Others"
                      checked={facilityDescription.includes("Others")}
                      onChange={(e) => handleCheckboxChange("Others", e)}
                    />
                    {facilityDescription.includes("Others") && (
                      <Form.Control
                        type="text"
                        placeholder="Enter description"
                        value={customDescription}
                        onChange={(e) => setCustomDescription(e.target.value)}
                        required
                      />
                    )}
                  </div>
                )}
              </Form.Group>
              {error && <Alert variant="danger mt-2">{error}</Alert>}

              <div className="d-flex justify-content-end">
                <Button
                  className="mt-4 mb-3"
                  id="button"
                  onClick={handleAddFacility}
                >
                  Confirm
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
